import { h, defineComponent } from 'vue';
import { useToast } from "vue-toastification";

export function showToastWithUndo({ message, undoFunction, type = "success", timeout = 5000 }) {
  const toast = useToast();

  const UndoComponent = defineComponent({
    props: {
      message: {
        type: String,
        required: true
      },
      undoFunction: {
        type: Function,
        required: true
      }
      // Removed timeout from props as it's not needed within the component
    },
    setup(props, { emit }) {
      const undo = () => {
        if (typeof props.undoFunction === 'function') {
          props.undoFunction();
        }
        emit('close-toast'); // Close the toast programmatically
      };
      return () => h('div', {
        style: "display: flex; align-items: center;"
      }, [
        h('span', {
          style: "flex: 1;" // Ensure the message takes up available space
        }, props.message),
        h('button', {
          onClick: undo,
          style: "color:#dddddd; background: none; border: 1px solid #dddddd; cursor: pointer; margin-left: 10px;"
        }, 'Undo')
      ]);
    }
  });

  // Trigger the toast with flexible timeout
  toast(
    {
      component: UndoComponent,
      props: {
        message,
        undoFunction,
      },
    },
    {
      type,
      timeout, // Use the timeout parameter here
      position: "bottom-right",
      closeOnClick: false, // Optional: Prevent closing on click if desired
      draggable: false, // Optional: Prevent dragging to close
    }
  );
}
